// components/LeadButtons.jsx
export const LeadButtons = ({ welcomeDetails, widgetDetails, onGenerateLead, disabled }) => {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center pb-2 g-2' style={{ gap: '0.5rem' }}>
      {/* <button
        className='btn outfit-regular font14 w-100'
        onClick={(e) => {
          handleChoice(e, welcomeDetails?.create_lead_choice);
          setIsLeadButtonHide(true);
        }}
        style={{
          color: widgetDetails?.bubble_text_color,
          background: widgetDetails?.client_bubble_color,
          border: `2px solid ${widgetDetails?.client_bubble_color}`,
          height: '40px',
          borderRadius: '34px',
        }}
        disabled={isButtonDisabled}
      >
        {welcomeDetails?.create_lead_choice}
      </button> */}
      <button
        className='btn outfit-regular font14 w-100'
        onClick={onGenerateLead}
        style={{
          backgroundColor: widgetDetails?.color,
          color: widgetDetails?.agent_bubble_text_color,
          borderRadius: '34px',
          border: 'none',
          height: '40px',
        }}
        disabled={disabled}
      >
        {welcomeDetails?.generate_lead_choice}
      </button>
    </div>
  );
};
